import { newAlert } from './alert_actions';
import {
  sendRequest,
  completeRequest,
  serverStatusError
} from './request_state';
import { history } from '../helpers/history';
import { submitSanitizer } from '../helpers/sanitizers/aspiringSupplierSignUpPageActionsSanitizer';
import RequestService from '../services/request_service';
import { fetchOrgData } from './global_setting_actions';
import { setCurrentUser } from './authentication_actions';

const requestNodeService = new RequestService('node');

export const createAspiringSuppliers = data => async dispatch => {
  dispatch(sendRequest('AspiringSupplierSignUp'));
  try {
    const payload = await requestNodeService.post(
      'users/createAspiringSuppliers',
      submitSanitizer(data.params)
    );

    const login = await requestNodeService.post('sessions', {
      login: payload.data.email,
      password: payload.data.identification
    });

    const currentUser = login.data.attributes;
    dispatch(setCurrentUser(currentUser));
    dispatch(fetchOrgData());
    dispatch(newAlert('success', 'sucess', 'Usuario Creado exitosamente'));

    history.push('/supplier-proposals');
  } catch (errors) {
    const e = await errors.json();
    if (e.errors) {
      if ('base' in e.errors) {
        dispatch(newAlert('error', 'ERROR:', e.errors.base));
      } else {
        dispatch(
          newAlert(
            'error',
            'ERROR:',
            e.errors.email || e.errors.identification || ''
          )
        );
      }
    }
  } finally {
    dispatch(completeRequest('AspiringSupplierSignUp'));
  }
};
